import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from "../../../blocks/PageMenu/PageMenu";
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import useGetInfoPrestacionEmpleadosHogar from "services/record/PrestacionEmpleadosHogar/useGetInfoPrestacionEmpleadosHogar";
import useGetPrestacionEmpleadosHogarByID from "services/record/PrestacionEmpleadosHogar/useGetPrestacionEmpleadosHogarByID";
import useGetPrestacionEmpleadosHogarByUser from "services/record/PrestacionEmpleadosHogar/useGetPrestacionEmpleadosHogarByUser";
import PrestacionEmpleadosHogar from "./PrestacionEmpleadosHogar";


const GridPrestacionEmpleadosHogar = ({ expedienteId = null, origen = null }) => {

    const {
        getPrestacionEmpleadosHogarByID,
        loadingGetPrestacionEmpleadosHogarByID,
        statusGetPrestacionEmpleadosHogarByID
    } = useGetPrestacionEmpleadosHogarByID();

    const {
        getInfoPrestacionEmpleadosHogar,
        loadingGetInfoPrestacionEmpleadosHogar,
        statusGetInfoPrestacionEmpleadosHogar
    } = useGetInfoPrestacionEmpleadosHogar();

    const {
        dataGetPrestacionEmpleadosHogarByUser,
        getPrestacionEmpleadosHogarByUser,
        loadingGetPrestacionEmpleadosHogarByUser,
        statusGetPrestacionEmpleadosHogarByUser
    } = useGetPrestacionEmpleadosHogarByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Certificado del Empleador para la Solicitud de Prestación Económica de los empleados de hogar";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    ////////////////////////////////////////
    // Carga inicial
    ////////////////////////////////////////
    useEffect(() => {
        getPrestacionEmpleadosHogarByUser(userId, expedienteIdByOrigen);
    }, []);

    ////////////////////////////////////////
    // Unificación HTTP
    ////////////////////////////////////////
    useEffect(() => {
        if (statusGetPrestacionEmpleadosHogarByID?.status) {
            setCurrentHttp({
                status: statusGetPrestacionEmpleadosHogarByID.status,
                statusText: statusGetPrestacionEmpleadosHogarByID.statusText
            });
        } else if (statusGetInfoPrestacionEmpleadosHogar?.status) {
            setCurrentHttp({
                status: statusGetInfoPrestacionEmpleadosHogar.status,
                statusText: statusGetInfoPrestacionEmpleadosHogar.statusText
            });
        } else if (statusGetPrestacionEmpleadosHogarByUser?.status) {
            setCurrentHttp({
                status: statusGetPrestacionEmpleadosHogarByUser.status,
                statusText: statusGetPrestacionEmpleadosHogarByUser.statusText
            });
        }
    }, [
        statusGetPrestacionEmpleadosHogarByID,
        statusGetInfoPrestacionEmpleadosHogar,
        statusGetPrestacionEmpleadosHogarByUser
    ]);

    ////////////////////////////////////////
    // Selección fila
    ////////////////////////////////////////
    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getPrestacionEmpleadosHogarByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    ////////////////////////////////////////
    // Generar formulario
    ////////////////////////////////////////
    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoPrestacionEmpleadosHogar(userId, expedienteIdByOrigen , (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    ////////////////////////////////////////
    // Mostrar botón generar
    ////////////////////////////////////////
    useEffect(() => {
        const arrData = dataGetPrestacionEmpleadosHogarByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetPrestacionEmpleadosHogarByUser]);

    ////////////////////////////////////////
    // Loader unificado
    ////////////////////////////////////////
    const isLoading = () => {
        return (
            loadingGetPrestacionEmpleadosHogarByID ||
            loadingGetInfoPrestacionEmpleadosHogar ||
            (loadingGetPrestacionEmpleadosHogarByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetPrestacionEmpleadosHogarByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {/* SUCCESS */}
            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <PrestacionEmpleadosHogar
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getPrestacionEmpleadosHogarByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {/* ERROR */}
            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridPrestacionEmpleadosHogar;